<template>
   <b-container class="page-content apiPage">
        <h3 class="text-center">API</h3>
        <p class="text-center">Will be updating soon!</p>
   </b-container>
</template>

<script>
export default {
    data(){
        return{
        }
    },
}
</script>

<style lang="scss">

    .apiPage h3{
        font-size: 25px;
        font-weight: bold;
        color: #666666;
    }
    .apiPage p{
        font-size: 17px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.76;
        letter-spacing: normal;
        text-align: center;
        color: #666666;        
        margin-bottom: 300px;
    }

</style>